import request from '@/utils/request'

export const getHomeData = (identify) => {
  return request.get('/page/detail', {
    params: {
      pageId: 0,
      identify
    }
  })
}
export const getOpenid = (code) => {
  return request.get('/getOpenid', { params: { code } })
}
export const getAccessList = (params) => {
  return request.get('getAccessList', {params})
}
export const getRouteList = (params) => {
  return request.get('getRouteList', {params})
}
export const getDormAccessList = (params) => {
  return request.get('getDormAccessList', {params})
}
export const getStudentScore = (params) => {
  return request.get('getStudentScore', {params})
}
export const getChildrenList = (params) => {
  return request.get('getChildrenList', {params})
}
export const saveFeedback = (params) => {
  return request.post('saveFeedback', params)
}
export const changePassword = (params) => {
  return request.post('changePassword', params)
}
export const getClassList = (userId) => {
  return request.get('/class/list', { params: { uid: userId } })
}
export const useLogout = (params) => {
  return request.post('useLogout', params)
}
